/* src/app/pages/doctores/listadoctores/listadoctores.component.scss */
/*# sourceMappingURL=listadoctores.component.css.map */
